module.exports = __webpack_public_path__ + "static/media/chevron-up.6ff5df4e.svg";